import { observer } from "mobx-react";
import React, { FC } from "react";
import { accountProductsConfigMap } from "constants/account-products-config";
import { ApplicationProductEnum } from "enums/application-product.enum";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { ProductInfo } from "routes/dashboard/routes/tools/components/ProductInfo/ProductInfo";
import { Box, Center } from "@chakra-ui/react";
import { SplashScreen } from "routes/dashboard/routes/tools/components/SplashScreen/SplashScreen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons";
import { SplashScreenReachout } from "routes/dashboard/routes/tools/components/SplashScreen/SplashScreenReachout";

const productConfig =
  accountProductsConfigMap[ApplicationProductEnum.DEVELOPERS_TAB];

interface IProps {
  accountStore: UserAccountStore;
}

export const DevelopersSplashScreen: FC<IProps> = observer(
  ({ accountStore }) => {
    return (
      <SplashScreen
        background={"purple.50"}
        topSection={
          <>
            <ProductInfo
              productConfig={productConfig}
              header={
                "Transfer lead data between Lead Management and your own software"
              }
              text={
                "Our developer tools open up data input and output methods for agents looking to take more control over the lead data put into, and taken out of Lead Management."
              }
              customBullet={
                <Center flexShrink={0}>
                  <FontAwesomeIcon icon={faCheckCircle} fontSize={28} />
                </Center>
              }
              bulletPoints={[
                "Push lead data into Lead Management via REST API",
                "Capture created and updated leads from Lead Management with webhooks",
                "Create multiple API keys and webhooks to handle separate pipelines easily",
              ]}
              productColor={"purple"}
              colorScheme={"purple"}
              accountBillingStore={accountStore.accountBillingStore}
              customCTA={<></>}
            />
          </>
        }
        bottomSection={
          <Box width={"600px"}>
            <SplashScreenReachout featureName="Developers Tab" />
          </Box>
        }
      />
    );
  }
);
